import React from 'react'
import {
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'
import { FormattedMessage } from 'react-intl'
import MessageBadge from './MessageBadge'

const MessagePriorityChip = ({ priority }) => {
  switch (priority) {
    case NOTI_PRIORITY_LOW.label: {
      return (
        <MessageBadge variant="primary" isTextUpperCase={false}>
          <FormattedMessage id="createNotification.dialog.notiPriority.low" />
        </MessageBadge>
      )
    }
    case NOTI_PRIORITY_HIGH.label: {
      return (
        <MessageBadge variant="info" isTextUpperCase={false}>
          <FormattedMessage id="createNotification.dialog.notiPriority.high" />
        </MessageBadge>
      )
    }
    case NOTI_PRIORITY_URGENT.label: {
      return (
        <MessageBadge variant="error" isTextUpperCase={false}>
          <FormattedMessage id="createNotification.dialog.notiPriority.urgent" />
        </MessageBadge>
      )
    }
    case NOTI_PRIORITY_EMERGENCY.label: {
      return (
        <MessageBadge variant="error" isTextUpperCase={false}>
          <FormattedMessage id="createNotification.dialog.notiPriority.emergency" />
        </MessageBadge>
      )
    }
    default: {
      return null
    }
  }
}

export default MessagePriorityChip
